"use client"

import { useCallback } from "react"
import { StatusReportType } from "@tc/ui-dfe/query"
import { StatusReportDownloadModal } from "../shared/StatusReportDownloadModal"

export interface ExportResubmissionReportProps {
  isOpen: boolean
  onClose: () => void
  onDownload: (params: {
    reportType: StatusReportType
    consignorIds: string[] | undefined
    dateRangeStart: string
    dateRangeEnd: string
  }) => void
}

export const ExportResubmissionReport = ({
  isOpen,
  onClose,
  onDownload,
}: ExportResubmissionReportProps) => {
  const handleReportDownload = useCallback(
    (
      consignorIds: string[] | undefined,
      dateRangeStart: string,
      dateRangeEnd: string,
    ) => {
      onDownload({
        reportType: StatusReportType.ExportResubmission,
        consignorIds,
        dateRangeStart: `${dateRangeStart}T00:00:00.000Z`,
        dateRangeEnd: `${dateRangeEnd}T23:59:59.999Z`,
      })
      onClose()
    },
    [onDownload, onClose],
  )

  return (
    <StatusReportDownloadModal
      isOpen={isOpen}
      onClose={onClose}
      onDownload={handleReportDownload}
      reportType={StatusReportType.ExportResubmission}
      context="exports"
    />
  )
}
